<template>
  <div>
    <booking-report-budget-utilization-add-edit-component />
  </div>
</template>

<script>
import BookingReportBudgetUtilizationAddEditComponent from "../../../components/Booking/Report/BookingReportBudgetUtilizationAddEditComponent";
export default {
  name: "BookingReportBudgetUtilizationEditView",
  components: { BookingReportBudgetUtilizationAddEditComponent }
};
</script>

<style scoped></style>
